import AbstractIntegration from "./AbstractIntegration.js";

/**
 * `SieImportIntegration` is a concrete implementation of `AbstractIntegration`
 * for import made via an Sie file.
 *
 */
export default class SieImportIntegration extends AbstractIntegration {
	isBeta() {
		return false;
	}

	getName() {
		return "SIE";
	}

	routeName() {
		return "sie";
	}

	static getType() {
		return "SieImportIntegration";
	}
}
